const CHAT_API_ROUTE = `${process.env.REACT_APP_CHAT_API_ROUTE}`;

const HOST_API_ROUTE = `${process.env.REACT_APP_HOST_API_ROUTE}`;
export const REACT_APP_HOST_ROUTE = `${process.env.REACT_APP_HOST_ROUTE}`;


const PICTURE_API_ROUTE = `${CHAT_API_ROUTE}/picture`
export const GET_PICTURE_API_ROUTE = `${PICTURE_API_ROUTE}/get-picture-by-id?pictureId=`;

const FILE_API_ROUTE = `${CHAT_API_ROUTE}/file`
export const GET_FILE_API_ROUTE = `${FILE_API_ROUTE}/get-file-by-id?fileId=`;

export const SEND_FILE_MESSAGE_API_ROUTE = (): string => {
    return `${window.serverUrl}/send-file`;
} ; 

export const SEND_MESSAGE_API_ROUTE = (): string => {
    return `${window.serverUrl}/send-message`;
} ;

export const SEND_PREVIEW_MESSAGE_API_ROUTE = (): string => {
    return `${window.serverUrl}/send-preview-message`;
} ;

export const GET_INIT_MESSAGE_API_ROUTE = (): string => {
    return `${window.serverUrl}/get-init-messages`;
};

export const GET_PREV_CHAT_MESSAGES_MESSAGE_API_ROUTE = (currentChatId: number): string => {
    return `${window.serverUrl}/get-prev-chat-messages?current-chat-id=${currentChatId}`;
};

